import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useReveal } from './useReveal';

interface RevealProps {
  children: ReactNode;
  className?: string;
  /** Stagger in ms, applied only when motion is allowed. */
  delay?: number;
  as?: 'div' | 'section' | 'li';
}

/** Fades and lifts its children into view once, or shows them instantly under reduced-motion. */
const Reveal = ({ children, className, delay = 0, as = 'div' }: RevealProps) => {
  const { ref, shown } = useReveal<HTMLDivElement>();
  const Tag = as as 'div';

  return (
    <Tag
      ref={ref}
      style={shown && delay ? { animationDelay: `${delay}ms` } : undefined}
      className={cn(
        shown ? 'motion-safe:animate-reveal-up' : 'opacity-0',
        className,
      )}
    >
      {children}
    </Tag>
  );
};

export default Reveal;